// extracted by mini-css-extract-plugin
export default {"star":"RatingStar_star__Z5Eit","filled":"RatingStar_filled__9UHlw"};